module.exports = __webpack_public_path__ + "media/img/corporate/first-line-fdf090a3c3c9f822cfc468d19f8f5244.svg";